import React from 'react'
import { useLocation } from 'react-router-dom'
import SidebarItems from 'MentalHealth/constants/SidebarItems'
import styles from './styles.module.scss'
import SidebarItem from './SidebarItem'
import useScopes from 'hooks/useScopes'

const Sidebar = ({ role }) => {
  const location = useLocation()
  const emptySidebarRoutes = ['/home', '/choose-profile']
  const { isAdmin } = useScopes()


  return (
    <div className={styles.root}>
      {SidebarItems.map((list, index) => {
        if (emptySidebarRoutes.includes(location.pathname) && isAdmin) {
          return null
        }

        return (
          <div key={index} className={styles.itemsContainer}>
            <div className={`text-center ${styles.menuTitle}`}>
              {list.title.toUpperCase()}
            </div>
            <div className={styles.items}>
              {list.items
                .filter((subItem) => subItem.allowed.includes(role))
                .map((subItem, subIndex) => (
                  <SidebarItem {...subItem} key={subIndex} />
                ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default Sidebar
